/* lazySizes config - must run before lazysizes.min.js initializes */
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.loadMode = 1;

(function() {
  'use strict';

  /* ============================================
     Tabs (FAQ page)
     ============================================ */
  function openTerms(evt, terms) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName('tabcontent');
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none';
    }
    tablinks = document.getElementsByClassName('tablinks');
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(' active', '');
    }
    document.getElementById(terms).style.display = 'block';
    evt.currentTarget.className += ' active';
  }
  window.openTerms = openTerms;

  // Auto-click default tab
  if (document.getElementById('defaultOpen')) {
    document.getElementById('defaultOpen').click();
  }

  /* ============================================
     Toggle visibility (footer FAQs, etc.)
     ============================================ */
  function cambiar(esto) {
    var vista = document.getElementById(esto).style.display;
    if (vista === 'none')
      vista = 'block';
    else
      vista = 'none';
    document.getElementById(esto).style.display = vista;
  }
  window.cambiar = cambiar;

})();
